import { createSlice } from '@reduxjs/toolkit';

import { IQuestionsData } from 'shared/types/questions';

const initialState: IQuestionsData = {
  questions: [],
  totalCount: 0,
  link: '',
};

const questionsSlice = createSlice({
  name: 'questions',
  initialState,
  reducers: {},
  selectors: {
    selectQuestions: state => state,
  },
});

export const {
  reducer: questionsReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: {},
  selectors: { selectQuestions },
} = questionsSlice;
